export const ArrayAggregationModeOptions = {
  ADD_ALL: 'add_all',
  ADD_FIRST_NON_BLANK: 'add_first_non_blank',
} as const;

export const ArrayValueResolutionOptions = {
  ADD_ONLY: 'add_only',
  OVERWRITE: 'overwrite',
  OVERWRITE_EXCEPT_NULL: 'overwrite_except_null',
} as const;

export const ARRAY_SEPARATORS = {
  comma: 'comma',
  newline: 'newline',
} as const;
